import React from "react";
import "./style.css";

export const Base = () => {
  return (
    <div className="base">
      <div className="overlap-wrapper">
        <div className="overlap">
          <img className="vector" alt="Vector" src="./img/vector.png" />
          <img className="img" alt="Vector" src="./img/vector-1.png" />
          <img className="vector-2" alt="Vector" src="./img/vector-2.png" />
          <div className="rectangle" />
          <div className="text-wrapper">Prototype in Figma</div>
          <a
            className="div"
            href="https://www.youtube.com/watch?v=aSp46UH-Vtg"
            rel="noopener noreferrer"
            target="_blank"
          >
            Open deze link!
          </a>
          <div className="text-wrapper-2">Veldonderzoek</div>
          <div className="veldonderzoek">
            <div className="overlap-group">
              <div className="p-oth-XL" />
              <div className="element-eux" />
              <img className="rectangle-2" alt="Rectangle" src="./img/rectangle.png" />
              <img className="rectangle-3" alt="Rectangle" src="./img/rectangle-1.png" />
              <div className="t-YLL">
                <img className="t-h-YLL" alt="T YLL" src="./img/t-6hyll.png" />
              </div>
            </div>
          </div>
          <img className="hero" alt="Hero" src="./img/hero.png" />
          <div className="main">
            <p className="het-primaire-doel">
              Het primaire doel van Team KMS is om de onderzoeksvraag &#34;Hoe kunnen we sensorgegevens op een visueel
              begrijpelijke manier presenteren, zodat fysiotherapeuten snel en efficiënt bewegingsanalyses kunnen
              uitvoeren?&#34; te adresseren. Door deze uitdaging aan te gaan, streven we ernaar om een geavanceerd
              systeem te ontwikkelen dat sensorgegevens intuïtief en overzichtelijk weergeeft. Dit stelt
              fysiotherapeuten in staat om bewegingspatronen van patiënten snel te analyseren, wat resulteert in
              nauwkeurige diagnoses en effectievere behandelplannen. Met Caspar, Joshua en Stevie die hun front-end
              development expertise inbrengen en Jan die verantwoordelijk is voor de back-end ontwikkeling, is ons team
              optimaal gepositioneerd om innovatieve oplossingen te creëren die voldoen aan de behoeften van zowel
              fysiotherapeuten als hun patiënten.
            </p>
            <p className="welkom-bij-team-CMS">
              <span className="span">
                Welkom bij Team CMS not KMS
                <br />
              </span>
              <span className="text-wrapper-3">Dit is onze one-pager voor MediaLab1</span>
            </p>
          </div>
          <div className="nav">
            <div className="insert-logo-here">
              <div className="text-wrapper-4">Team CMS not KMS</div>
            </div>
          </div>
          <img className="logo" alt="Logo" src="./img/logo.svg" />
          <img className="group" alt="Group" src="./img/group.png" />
          <div className="row">
            <div className="caspar">
              <div className="overlap-group-2">
                <div className="colored-hard-shadow" />
                <img className="rectangle-4" alt="Rectangle" src="./img/rectangle-1-1.svg" />
              </div>
              <p className="p">
                <span className="text-wrapper-5">
                  Caspar <br />
                </span>
                <span className="text-wrapper-6">Front-end developer</span>
              </p>
            </div>
            <div className="joshua">
              <div className="overlap-group-2">
                <div className="colored-hard-shadow-2" />
                <img className="rectangle-5" alt="Rectangle" src="./img/rectangle-1-2.svg" />
              </div>
              <p className="div-2">
                <span className="text-wrapper-5">
                  Joshua
                  <br />
                </span>
                <span className="text-wrapper-6">Front-end developer</span>
              </p>
            </div>
            <div className="jan">
              <div className="overlap-group-2">
                <div className="colored-hard-shadow" />
                <img className="rectangle-4" alt="Rectangle" src="./img/rectangle-1-3.svg" />
              </div>
              <p className="p">
                <span className="text-wrapper-5">
                  Jan
                  <br />
                </span>
                <span className="text-wrapper-6">Back-end developer</span>
              </p>
            </div>
            <div className="stevie">
              <div className="overlap-2">
                <div className="colored-hard-shadow-3" />
                <img className="rectangle-5" alt="Rectangle" src="./img/rectangle-1-4.svg" />
              </div>
              <p className="div-2">
                <span className="text-wrapper-5">
                  Stevie
                  <br />
                </span>
                <span className="text-wrapper-6">Front-end developer</span>
              </p>
            </div>
          </div>
          <div className="breaker">
            <div className="overlap-3">
              <div className="shadow" />
              <div className="bg" />
              <p className="hoe-kun-je-de-data">
                <span className="text-wrapper-7">“</span>
                <span className="text-wrapper-8">Hoe kun je de </span>
                <span className="text-wrapper-7">data</span>
                <span className="text-wrapper-8"> van de </span>
                <span className="text-wrapper-7">sensoren visualiseren, </span>
                <span className="text-wrapper-8">zodat de fysiotherapeut snel en efficient de</span>
                <span className="text-wrapper-7"> bewegingssanalyse </span>
                <span className="text-wrapper-8">kan uitvoeren.</span>
                <span className="text-wrapper-7">” </span>
              </p>
              <div className="picture">
                <div className="overlap-group-3">
                  <div className="rectangle-6" />
                  <img className="rectangle-7" alt="Rectangle" src="./img/rectangle-4.png" />
                </div>
              </div>
              <div className="text-wrapper-9">Onderzoeksvraag</div>
            </div>
          </div>
          <div className="rectangle-8" />
          <div className="text-wrapper-10">Concept</div>
          <p className="dashboard-met-simple">
            Dashboard met simple visualisatie van data&nbsp;&nbsp;
            <br />
            Verbetering of verslechtering in kaart brengen&nbsp;&nbsp; <br />
            Op basis van de algemene score aanbevelingen met oefeningen <br />
            voor de patient (score komt voor uit Machine Learning)&nbsp;&nbsp;
            <br />
            Laagdrempeling doordat het gebruiksvriendelijk is (denk aan digitale toegankelijkheid)
          </p>
          <img className="rectangle-9" alt="Rectangle" src="./img/rectangle-11.png" />
          <div style={{ maxWidth: '100%', margin: '0 auto', position: "absolute", bottom: "12rem", left: "5%" }}>
            
            <style>position="absoulte"</style>
            <iframe
            width="1280" // Set the width to 1280 pixels
            height="720" // Set the height to 720 pixels, maintaining a 16:9 aspect ratio
              src="https://www.youtube.com/embed/aSp46UH-Vtg"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen>
            </iframe>
          </div >
          <p className="text-wrapper-11">
            Voor het veldonderzoek heeft het team verschillende valpreventie cursussen bijgewoond om te zien hoe dit
            wordt aangepakt, teamleden hebben naast de preventieve cursussen ook meegedaan aan “50+ Sporten” waar ze
            hebben gezien hoe ouderen fit en in vorm kunnen blijven om het valrisico te verminderen. Op deze manier
            konden ze zich beter inleven in wat er nodig is om gezond te blijven op een oudere leeftijd. Waardoor wij
            aan de hand van dit onderzoek een conclusie hebben getrokken, dat de ouderen meer moeten worden betrokken in
            het aansterken van hun eigen kracht. Hierdoor hebben wij ervoor gekozen om de focus te leggen binnen ons
            concept, om de ouderen aan de hand van machine learning, te adviseren in de juiste oefeningen. Om zo hun
            kracht en mobiliteit te versterken. De data die gebruikt wordt voor machine learning komt dan voort uit de
            sensordata.
          </p>
        </div>
      </div>
    </div>
  );
};
